import { createGlobalStyle } from 'styled-components';
import { fontSizes, normalFontFamily } from './consts.ts';

export const GlobalStyles = createGlobalStyle`
  html,
  body {
    max-width: 100%;
    margin: 0;
    padding: 0;
    background: ${({ theme }) => theme.getColor('bgScreen')};
    font-size: ${fontSizes.mobile}px;
    font-weight: 400;
    font-family: ${normalFontFamily};
    line-height: ${21 / fontSizes.mobile};
    color: ${({ theme }) => theme.getColor('completelyWhite')};
    letter-spacing: -0.02em;
    overscroll-behavior: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    ${({ theme }) => theme.getUpMedia('md')} {
      font-size: ${({ theme }) => theme.responsive(fontSizes.desktop)}px;
      line-height: ${16 / fontSizes.desktop};
    }
  }

  * {
    touch-action: manipulation;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.getColor('accentPrimary')};
    }
  }

  img {
    display: block;
    max-width: 100%;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }

  p {
    margin: 0;
  }

  ul {
    list-style-type: disc;
  }

  menu{
    margin: 0;
    padding: 0;
  }

  /*noinspection ALL*/
  .tsqd-open-btn {
    width: 20px !important;
    height: 20px !important;
  }

  div[data-radix-popper-content-wrapper] {
    z-index: 100 !important;
  }

  /*noinspection CssUnusedSymbol*/
  #notistack-snackbar{
    word-break: break-all;
  }

  /* React Pro Sidebar стили */
  /*
  .ps-sidebar-open {
    transform: translateX(0) !important;
  }

  .ps-sidebar-container {
    backdrop-filter: blur(10px) !important;
    -webkit-backdrop-filter: blur(10px) !important;
  }

  .ps-menuitem-root:hover {
    background: rgba(255, 255, 255, 0.1) !important;
  }

  !* Скрыть скроллбар для sidebar *!
  .ps-sidebar-container::-webkit-scrollbar {
    display: none;
  }

  .ps-sidebar-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  */

`;
